/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/MindHarborOrderHistory/UserOrderHistory.Helper',[
    'jquery',
    'lodash',
    'global/all',
    './UserOrderHistory.Constants'
], function ($, _, Roc, Selectors) {
    'use strict';

    function createSearchRequest(pageNum) {
        var status = $(Selectors.searchBar.status).val();
        var sortOrder = $(Selectors.searchBar.sortOrder).val();
        var customerId = $(Selectors.searchBar.customerId).val();
        var shipToId = $(Selectors.searchBar.shipTo).val();
        var filterNumbers = $(Selectors.searchBar.filterNumbers).val();

        var startDate = '';
        var endDate = '';

        var dateRangeVal = $(Selectors.searchBar.dateRange).val();
        if (dateRangeVal) {
            var dates = dateRangeVal.split(" - ");
            startDate = dates[0];
            endDate = dates[1];
        }

        return {
            page: pageNum,
            sortBy: sortOrder,
            status: status,
            startDate: startDate,
            endDate: endDate,
            selectedCustomerId: customerId,
            selectedShipToId: shipToId,
            filterNumbers: filterNumbers
        };
    }

    function setPagingInfo(userOrders) {
        userOrders.totalPages = Math.ceil(userOrders.totalItems / userOrders.pageSize);
        userOrders.startIndex = (userOrders.currentPage - 1) * userOrders.pageSize + 1;
        if (userOrders.orders && userOrders.orders.length) {
            userOrders.endIndex = (userOrders.currentPage - 1) * userOrders.pageSize + userOrders.orders.length;
        } else {
            userOrders.endIndex = 0;
        }
    }

    function toggleDetailsBtnText(btn) {
        if (btn.hasClass('collapsed')) {
            btn.text('Details');
        } else {
            btn.text('Collapse');
        }
    }

    var UserOrderHistoryHelper = {
        createSearchRequest: createSearchRequest,
        setPagingInfo: setPagingInfo,
        toggleDetailsBtnText: toggleDetailsBtnText
    };

    Roc.Logger.debug('UserOrderHistory.Helper.js Loaded:', UserOrderHistoryHelper);

    return UserOrderHistoryHelper;
});
